export const CAREERS_BASE = '/careers'

export const getCareersJobUrl = (jobId) => {
  if (!jobId) return CAREERS_BASE
  return `${CAREERS_BASE}/${jobId}`
}

export const isCareersRoute = (pathname = '') =>
  pathname === CAREERS_BASE || pathname.startsWith(`${CAREERS_BASE}/`)

export const getJobCatalogBase = (pathname = '') =>
  isCareersRoute(pathname) ? CAREERS_BASE : '/jobs/browse'

export const getJobDetailUrl = (jobId, pathname = '') =>
  isCareersRoute(pathname) ? getCareersJobUrl(jobId) : `/jobs/${jobId}`
